import React, { useState, useEffect } from 'react';
import './AllFeatures.css';
import { jwtDecode } from "jwt-decode";
import biomelogo from '../../Assets/photo/biomelogo.png';

const AllFeatures = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const token = localStorage.getItem("token");
  let decoded = null;
  try {
    if (token) {
      decoded = jwtDecode(token);
    }
  } catch (err) {
    decoded = null;
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.style.overflow = !mobileMenuOpen ? 'hidden' : 'auto';
  };

  // Intersection observer for reveal animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll('.reveal').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // Close menu when clicking nav links
  const handleNavClick = () => {
    setMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="allfeatures-container">
      {/* HEADER */}
      <header className="header">
        <div className="container head-nav">
          <div className="brand">
            <a href="/" className="logo-link">
              <img src={biomelogo} alt="BioME Logo" />
            </a>
            <strong>BioME Features</strong>
          </div>
          <nav className="nav-desktop">
            <a href="/#features">Features</a>
            <a href="/page/allfeatures">All Features</a>
            <a href="/page/news">News</a>
            <a href="/#pricing">Pricing</a>
            <a href="/#faq">FAQ</a>
            <a
              className="home-btn cta-nav"
              href={token && decoded ? (decoded?.roleId === "admin" ? "/admin/dashboard" : "/user/dashboard") : "/auth/signup"}
            >
              {token && decoded ? "Dashboard" : "Create"}
            </a>
          </nav>
          {token && decoded ? (
            <a
              href={decoded?.roleId === "admin" ? "/admin/dashboard" : "/user/dashboard"}
              className="home-btn white admin-header-btn"
            >
              Dashboard
            </a>
          ) : (
            <a href="/auth/login" className="home-btn white admin-header-btn">
              Log In
            </a>
          )}
          <button className="mobile-menu-btn" onClick={handleMobileMenuToggle}>☰</button>
        </div>
      </header>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <button className="close-btn" onClick={closeMobileMenu}>×</button>
        <div className="mobile-nav">
          <a href="/#features" onClick={handleNavClick}>Features</a>
          <a href="/page/allfeatures" onClick={handleNavClick}>All Features</a>
          <a href="/page/news" onClick={handleNavClick}>News</a>
          <a href="/#pricing" onClick={handleNavClick}>Pricing</a>
          <a href="/#faq" onClick={handleNavClick}>FAQ</a>
          <a
            href={token && decoded ? (decoded?.roleId === "admin" ? "/admin/dashboard" : "/user/dashboard") : "/auth/signup"}
            onClick={handleNavClick}
            style={{
              background: "var(--grad-a)",
              color: "white",
              padding: "12px 20px",
              borderRadius: "999px",
              textAlign: "center",
            }}
          >
            {token && decoded ? "Go to Dashboard" : "Create My BioME"}
          </a>
        </div>
      </div>

      {/* HERO */}
      <section className="all-features-hero reveal">
        <div className="container">
          <h1 className='text-center'>All of BioME.com Features</h1>
          <p className='text-center'>Compare Free, Monthly, and Annual BioMExplorer tiers</p>
        </div>
      </section>

      {/* DESKTOP TABLE */}
      <section className="reveal">
        <div className="container table-wrap">
          <div className="divider"></div>
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>Free</th>
                <th>BioMExplorer (Billed Monthly)</th>
                <th>BioMExplorer (Billed Annually)</th>
              </tr>
            </thead>
            <tbody>
              {/* PRICING */}
              <tr className="section-header">
                <th colSpan="4">Pricing</th>
              </tr>
              <tr>
                <th>Tier Price</th>
                <td>
                  <div className="feature-price">
                    $0<small>Forever Free</small>
                  </div>
                </td>
                <td>
                  <div className="feature-price">
                    $6.5<small>Per Month</small>
                  </div>
                </td>
                <td>
                  <div className="feature-price">
                    $65<small>Per Year</small>
                  </div>
                </td>
              </tr>

              {/* CORE ACCESS */}
              <tr className="section-header">
                <th colSpan="4">Core Access</th>
              </tr>
              <tr>
                <th>Custom Username (URL)</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Unlimited Links</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Block/Widget Organisation</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Custom Domain</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Headers/Sub-Headers modules</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* ANALYTICS & DATA */}
              <tr className="section-header">
                <th colSpan="4">Analytics & Data</th>
              </tr>
              <tr>
                <th>Advanced Analytics</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Email Collection</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Number Collection</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* VISUAL CUSTOMISATION */}
              <tr className="section-header">
                <th colSpan="4">Visual Customisation</th>
              </tr>
              <tr>
                <th>Custom Wallpaper</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Premium Wallpaper</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Image Banner</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Template Access</th>
                <td>Standard</td>
                <td>All</td>
                <td>Custom</td>
              </tr>
              <tr>
                <th>Link Highlighting Effects</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Full Link Designs</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Pixel Panels</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>(Dynamic) Pixel Panels</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* EVENTS & HOSTING */}
              <tr className="section-header">
                <th colSpan="4">Events & Hosting</th>
              </tr>
              <tr>
                <th>Event Hosting w. Email Signups</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Send SignUps Event Commencement via Email</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Event Countdown</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Pop-Up Campaign</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Map Embed</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* AUDIO & VISUALS */}
              <tr className="section-header">
                <th colSpan="4">Audio & Visuals</th>
              </tr>
              <tr>
                <th>Audio CTA</th>
                <td>5s</td>
                <td>10m</td>
                <td>10m</td>
              </tr>
              <tr>
                <th>Cinematic Play Capability</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Youtube Embed</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* MEDIA & ALBUMS */}
              <tr className="section-header">
                <th colSpan="4">Media & Albums</th>
              </tr>
              <tr>
                <th>Dynamic Album Tiles</th>
                <td>4</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <th>Album Manual/Auto-Play Toggle</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Media Space</th>
                <td>Expandable 60MB</td>
                <td>Expandable 5GB</td>
                <td>Expandable 5GB</td>
              </tr>
              <tr>
                <th>Instagram Album Grids</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Horizontal Album Scroll/s</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Singular Formatted Poster</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* INTERACTION */}
              <tr className="section-header">
                <th colSpan="4">Interaction</th>
              </tr>
              <tr>
                <th>Description Textboard</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Form Data Collection</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Collect up to 5 fields</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Email Collection for Event Ticketing</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* PAYMENT OPTIONS */}
              <tr className="section-header">
                <th colSpan="4">Payment Options</th>
              </tr>
              <tr>
                <th>One-time Payment Option</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* MOBILE TABLE */}
      <section className="reveal">
        <div className="container mobile-table-container">
          <table className="mobile-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Free</th>
                <th>BioMExplorer (Billed Monthly)</th>
                <th>BioMExplorer (Billed Annually)</th>
              </tr>
            </thead>
            <tbody>
              {/* PRICING */}
              <tr className="section-header">
                <th colSpan="4">Pricing</th>
              </tr>
              <tr>
                <th>Tier Price</th>
                <td>
                  <div className="feature-price">
                    $0<small>Forever Free</small>
                  </div>
                </td>
                <td>
                  <div className="feature-price">
                    $6.5<small>Per Month</small>
                  </div>
                </td>
                <td>
                  <div className="feature-price">
                    $65<small>Per Year</small>
                  </div>
                </td>
              </tr>

              {/* CORE ACCESS */}
              <tr className="section-header">
                <th colSpan="4">Core Access</th>
              </tr>
              <tr>
                <th>Custom Username (URL)</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Unlimited Links</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Block/Widget Organisation</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Custom Domain</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Headers/Sub-Headers modules</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* ANALYTICS & DATA */}
              <tr className="section-header">
                <th colSpan="4">Analytics & Data</th>
              </tr>
              <tr>
                <th>Advanced Analytics</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Email Collection</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Number Collection</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* VISUAL CUSTOMISATION */}
              <tr className="section-header">
                <th colSpan="4">Visual Customisation</th>
              </tr>
              <tr>
                <th>Custom Wallpaper</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Premium Wallpaper</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Image Banner</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Template Access</th>
                <td>Standard</td>
                <td>All</td>
                <td>Custom</td>
              </tr>
              <tr>
                <th>Full Link Designs</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Pixel Panels</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>(Dynamic) Pixel Panels</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* EVENTS & HOSTING */}
              <tr className="section-header">
                <th colSpan="4">Events & Hosting</th>
              </tr>
              <tr>
                <th>Event Hosting w. Email Signups</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Send SignUps Event Commencement via Email</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Event Countdown</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Pop-Up Campaign</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Map Embed</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* AUDIO & VISUALS */}
              <tr className="section-header">
                <th colSpan="4">Audio & Visuals</th>
              </tr>
              <tr>
                <th>Audio CTA</th>
                <td>5s</td>
                <td>10m</td>
                <td>10m</td>
              </tr>
              <tr>
                <th>Cinematic Play Capability</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Youtube Embed</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* MEDIA & ALBUMS */}
              <tr className="section-header">
                <th colSpan="4">Media & Albums</th>
              </tr>
              <tr>
                <th>Dynamic Album Tiles</th>
                <td>4</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <th>Album Manual/Auto-Play Toggle</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Media Space</th>
                <td>Expandable 60MB</td>
                <td>Expandable 5GB</td>
                <td>Expandable 5GB</td>
              </tr>
              <tr>
                <th>Instagram Album Grids</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Horizontal Album Scroll/s</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Singular Formatted Poster</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* INTERACTION */}
              <tr className="section-header">
                <th colSpan="4">Interaction</th>
              </tr>
              <tr>
                <th>Description Textboard</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Form Data Collection</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Collect up to 5 fields</th>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
              <tr>
                <th>Email Collection for Event Ticketing</th>
                <td><span className="cross">✗</span></td>
                <td><span className="cross">✗</span></td>
                <td><span className="check">✓</span></td>
              </tr>

              {/* PAYMENT OPTIONS */}
              <tr className="section-header">
                <th colSpan="4">Payment Options</th>
              </tr>
              <tr>
                <th>One-time Payment Option</th>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
                <td><span className="check">✓</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ textAlign: "center", marginBottom: "80px" }}>
          <a
            href={token && decoded ? (decoded?.roleId === "admin" ? "/admin/dashboard" : "/user/dashboard") : "/auth/signup"}
            className="home-btn get-started-btn"
          >
            {token && decoded ? "Go to Dashboard" : "Get Started"}
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container foot">
          <img src={biomelogo} alt="BioME Logo" />
          <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <a href="/#features">Features</a>
            <a href="/page/allfeatures">All Features</a>
            <a href="/page/news">News</a>
            <a href="/#pricing">Pricing</a>
            <a href="/#faq">FAQ</a>
          </div>
          <small>© {new Date().getFullYear()} BioME.com. All rights reserved.</small>
        </div>
      </footer>
    </div>
  );
};

export default AllFeatures;
